/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Option from './Option/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/ScheduleOptions/Content/SlotSelect/Content/Content/Options"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let daySlotsSlotsValueData = fromData.useDataValue({ viewPath,
context: 'day_slots',
path: 'slots',
})
let tabSchedulingSlotIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling.slot_id',
})
let aggregateData = fromHelpers.groupSlots(daySlotsSlotsValueData, tabSchedulingSlotIdValueData)
  return (<React.Fragment
>
<div
  data-testid="Options.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-tY85I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-2-tY85I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Options.List"
  data-view-path={viewPath}
 style={{'--g-3-tY85I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(aggregateData) && aggregateData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="group"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Option(${item?.id ?? item?._id ?? index})`}
      >
<Option
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Option(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }